export { default } from "./tasksTableContainer";
